module.exports = __webpack_public_path__ + "7a921dd60180b6f56b5b0ac6695854da.png";